import React, { useState, useRef } from 'react';

export default function HierarchyImg() {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });

  const wrapperRef = useRef(null);

  const ZOOM_STEP = 0.25;
  const MIN_SCALE = 1;
  const MAX_SCALE = 4;

  // Zoom functions
  const zoomIn = () => {
    setScale(prev => Math.min(prev + ZOOM_STEP, MAX_SCALE));
  };

  const zoomOut = () => {
    setScale(prev => Math.max(prev - ZOOM_STEP, MIN_SCALE));
  };

  // Drag start
  const handleMouseDown = (e) => {
    if (scale <= 1) return;
    setIsDragging(true);
    setStartPos({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  // Drag move
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - startPos.x,
      y: e.clientY - startPos.y
    });
  };

  const handleMouseUp = () => setIsDragging(false);

  // Reset view
  const handleReset = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  // Fullscreen toggle
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      wrapperRef.current?.requestFullscreen?.().catch(err => {
        console.warn("Fullscreen failed:", err);
      });
    } else {
      document.exitFullscreen?.();
    }
  };

  return (
    <div
      ref={wrapperRef}
      style={{
        padding: '2rem',
        maxWidth: '1400px',
        margin: '0 auto',
        minHeight: '100vh',
        boxSizing: 'border-box'
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1.5rem'
      }}>
        <h1 style={{
          margin: 0,
          color: '#2c3e50',
          fontSize: '2.2rem'
        }}>
          Organization Hierarchy
        </h1>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={zoomOut}
            disabled={scale <= MIN_SCALE}
            style={{
              padding: '8px 14px',
              border: 'none',
              borderRadius: '6px',
              background: scale <= MIN_SCALE ? '#e9ecef' : '#007bff',
              color: 'white',
              cursor: scale <= MIN_SCALE ? 'not-allowed' : 'pointer',
              fontSize: '1.1rem',
              fontWeight: 600
            }}
          >
            −
          </button>

          <button
            onClick={zoomIn}
            disabled={scale >= MAX_SCALE}
            style={{
              padding: '8px 14px',
              border: 'none',
              borderRadius: '6px',
              background: scale >= MAX_SCALE ? '#e9ecef' : '#007bff',
              color: 'white',
              cursor: scale >= MAX_SCALE ? 'not-allowed' : 'pointer',
              fontSize: '1.1rem',
              fontWeight: 600
            }}
          >
            +
          </button>

          <button
            onClick={handleReset}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '6px',
              background: '#6c757d',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            Reset
          </button>

          <button
            onClick={toggleFullScreen}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '6px',
              background: document.fullscreenElement ? '#dc3545' : '#28a745',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            {document.fullscreenElement ? 'Exit' : 'Full Screen'}
          </button>
        </div>
      </div>

      {/* Image container */}
      <div
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        style={{
          width: '100%',
          height: 'calc(100vh - 140px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          background: '#f8f9fa',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default',
          userSelect: 'none'
        }}
      >
        <img
          src="/assets/hierarchy.svg"
          alt="Organization hierarchy diagram"
          draggable={false}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
            transformOrigin: 'center center',
            transition: isDragging ? 'none' : 'transform 0.2s ease',
            objectFit: 'contain'
          }}
        />
      </div>
    </div>
  );
}